import styled, { createGlobalStyle } from 'styled-components';
import { exportIds } from '../../config/config';

export const ExportStyles = createGlobalStyle`
  #${exportIds.pdfExportRoot} #mobile-header-container,
  #${exportIds.pdfExportRoot} div:has(> .mobile-menu-container) {
    display: none !important;
  }

  #${exportIds.pdfExportRoot} .ant-spin-nested-loading .ant-spin-blur,
  #${exportIds.pdfExportRoot} .ant-spin {
    display: none !important;
  }
  #${exportIds.pdfExportRoot} .ant-spin-nested-loading .ant-spin-container {
    filter: none !important;
  }
`;

export const ExportWrapper = styled.div<{ $contentWidth: number }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-width: ${({ $contentWidth }) => $contentWidth}px;
  height: 100%;
  overflow: auto;
  z-index: -1;
  visibility: hidden;
  pointer-events: none;
  background: ${({ theme }) => theme.white};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
`;


export const ExportContent = styled.div<{ $contentWidth: number }>`
  width: ${({ $contentWidth }) => $contentWidth}px;
  min-width: ${({ $contentWidth }) => $contentWidth}px;
  min-height: 100%;
  background: ${({ theme }) => theme.greyBackground};
`;
